import moment from "moment";
import loginModel from "../static/login.model";
import { Md5 } from "ts-md5";
import { URLSearchParams } from "url";
import { clearLocalStorage, exitFromApplication, getIsOnline, isJsonParsable } from "../utilities/common.utilities";

import axios, { AxiosHeaders } from "axios";
import api, { apiWithoutInterceptor } from "./api";

const httpClient = axios.create({
baseURL: process.env.REACT_APP_API_URL,
});
export default httpClient;

export function serviceMain() {
    return process.env.REACT_APP_API_URL
}

// Chiamate GET 
// Stringa di input = [secretKey1].[endpoint + eventuale QueryString].[FidelitySalus-TS].[secretKey2]
export function setHeader(url:string, queryParams?: URLSearchParams){
    let userInfo: loginModel = JSON.parse(localStorage.getItem("user") || '""');
    let ticksDateExpireOn  = (( moment().valueOf() * 10000) + 621355968000000000); //ticks

    let FidelitySalusTS= ticksDateExpireOn ? ticksDateExpireOn.toString() : '0';
    let FidelitySalusToken = userInfo.token; 
    let secretKey1 = userInfo.secretKey1;
    let secretKey2 = userInfo.secretKey2;

    const headers: Headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('Accept', 'application/json');

    let FidelitySalusMessageAuth: string;

    if(queryParams){
        FidelitySalusMessageAuth = secretKey1+'.'+`${url}?${queryParams}`+'.'+FidelitySalusTS+'.'+secretKey2;
    } else {
        FidelitySalusMessageAuth = secretKey1+'.'+`${url}`+'.'+FidelitySalusTS+'.'+secretKey2;
    }

    headers.append('FidelitySalus-MessageAuth', Md5.hashAsciiStr(FidelitySalusMessageAuth));
    headers.append('FidelitySalus-TS', FidelitySalusTS);
    headers.append('FidelitySalus-Token', FidelitySalusToken);

    return headers;
}

export function sessionUserValid(){
    let userExpireLogin;
    
    if(isJsonParsable(localStorage.getItem("user"))){
        userExpireLogin = JSON.parse(localStorage.getItem("user") || '""').expireOn
        ? JSON.parse(localStorage.getItem("user") || '""').expireOn.split(".")[0].replace("T", " ").replaceAll("-", "/")
        : 0;

        if (userExpireLogin) {
            const today = moment().valueOf() * 10000 + 621355968000000000;
            // momento in cui scade la sessione dell'utente
            const _tempExpireLogin = moment(userExpireLogin).valueOf() * 10000 + 621355968000000000;
            // se momento in cui scade la sessione è maggiore di quella attuale sei ancroa loggato
            if (_tempExpireLogin > today) {
              
              return true;
            } else {
                clearLocalStorage();
                return false;
            }
          // se userexpirelogin non trova niente
          } else {
            clearLocalStorage();
            return false;
          }
    } 
    // se errore in fase di parse
    else {
        clearLocalStorage();
        return false;
    }
    
      
}

export async function _get(url: string, serviceTimeName: string, localSt: string, queryParams?: URLSearchParams){
    try {

        let urlService: string;
        if(queryParams){
            urlService = `${url}?${queryParams}`;
        } else {
            urlService = url;
        }
        
          if (navigator.onLine) {
            const now:number = moment().valueOf() * 10000 + 621355968000000000;
            if( localStorage.getItem(serviceTimeName) ) {
              const serviceTime: number = parseInt(localStorage.getItem(serviceTimeName) || '0');
              if((now - serviceTime) >= 72000000000) { // 72000000000 --> 2 hour
    
                const data = await fetch(serviceMain() + urlService, {
                  method: "GET",
                  headers: queryParams ? setHeader(url, queryParams) : setHeader(url),
                });
                
                const jsonData = await data.json();
                
                localStorage.setItem(localSt,JSON.stringify(jsonData));
                
                localStorage.setItem(serviceTimeName, (moment().valueOf() * 10000 + 621355968000000000).toString());
                 return (jsonData);
              } else {
                if(isJsonParsable(localStorage.getItem(localSt))) {
                  return JSON.parse(localStorage.getItem(localSt) || '' );
                }
              }
            } else {
              const data = await fetch(serviceMain() + urlService, {
                method: "GET",
                headers: queryParams ? setHeader(url, queryParams) : setHeader(url),
              });
            
               const jsonData = await data.json();
               localStorage.setItem(localSt,JSON.stringify(jsonData));
              localStorage.setItem(serviceTimeName, (moment().valueOf() * 10000 + 621355968000000000).toString());
               return (jsonData);
            }
          } else { //offline
            if(isJsonParsable(localStorage.getItem(localSt))) {
              return JSON.parse(localStorage.getItem(localSt) || '' );
            }
          }
          
        } catch(err) {
          console.log(err);
          if(isJsonParsable(localStorage.getItem(localSt))) {
            return JSON.parse(localStorage.getItem(localSt) || '' );
          } else {
            // exitFromApplication();
          }
        }
}

// settare gli header richieste dalle api
export function setAxiosHeader(url:string, queryParams?: URLSearchParams){
    // recupera le info dell'utente al momento della llgin (ex: token, secret key...)
    let userInfo: loginModel = JSON.parse(localStorage.getItem("user") || '""');
    // momento della chimata
    let ticksDateExpireOn  = (( moment().valueOf() * 10000) + 621355968000000000); //ticks

    let FidelitySalusTS= ticksDateExpireOn ? ticksDateExpireOn.toString() : '0';
    let FidelitySalusToken = userInfo.token; 
    let secretKey1 = userInfo.secretKey1;
    let secretKey2 = userInfo.secretKey2;

    const headers: AxiosHeaders = new AxiosHeaders();
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('Accept', 'application/json');

    let FidelitySalusMessageAuth: string;

    if(queryParams){
        FidelitySalusMessageAuth = secretKey1+'.'+`${url}?${queryParams}`+'.'+FidelitySalusTS+'.'+secretKey2;
    } else {
        FidelitySalusMessageAuth = secretKey1+'.'+`${url}`+'.'+FidelitySalusTS+'.'+secretKey2;
    }

    headers.set('FidelitySalus-MessageAuth', Md5.hashAsciiStr(FidelitySalusMessageAuth));
    headers.set('FidelitySalus-TS', FidelitySalusTS);
    headers.set('FidelitySalus-Token', FidelitySalusToken);

    return headers;
}

export async function _getAxios(url: string, serviceTimeName: string, localSt: string, queryParams?: URLSearchParams){
    try {
      // 
        let urlService: string;
        //se abbiamo parametri 
        if(queryParams){
            urlService = `${url}?${queryParams}`;
        } else {
        // se non abbiamo parametri
            urlService = url;
        }
        // funzione per capire se utente è o no online
          if (navigator.onLine) {
            //andiamo a prendere i ticks per settare lo stato nel momento della chiamata
            const now:number = moment().valueOf() * 10000 + 621355968000000000; // in now abbiamo i ticks del momento corrente
            // se nel localstorage esiste l'informazione del momento in cui viene chiamato il servizio
            if( localStorage.getItem(serviceTimeName) ) {
              //prendo le stringhe dal localstorage e la parsa in numero
              const serviceTime: number = parseInt(localStorage.getItem(serviceTimeName) || '0');
              //cofrontiamo il momento attuale con quello dell'ultima chiamata al servizio
              //se adesso meno il passato maggiore di 2 ore
              if((now - serviceTime) >= 72000000000) { // 72000000000 --> 2 hour
                // parte la chiamata
                return await api.get(urlService, {
                    headers: queryParams ? setAxiosHeader(url, queryParams) : setAxiosHeader(url),
                }).then( data => {
                    // console.log("chiamata axios --> " + JSON.stringify(data.data));
                    // se localst è stato passato setto nuova data e nuovi risultati
                    if(localSt){
                      localStorage.setItem(localSt,JSON.stringify(data.data));
                      localStorage.setItem(serviceTimeName, (moment().valueOf() * 10000 + 621355968000000000).toString());
                    }
                    
                    return data.data
                })

              } else {
                if(isJsonParsable(localStorage.getItem(localSt))) {
                  return JSON.parse(localStorage.getItem(localSt) || '' );
                }
              }
            } else {

            return await api.get(urlService, {
                headers: queryParams ? setAxiosHeader(url, queryParams) : setAxiosHeader(url),
            }).then( data => {
                // console.log("chiamata axios --> " + JSON.stringify(data.data));
                if(localSt && data?.data){
                localStorage.setItem(localSt,JSON.stringify(data.data));
                localStorage.setItem(serviceTimeName, (moment().valueOf() * 10000 + 621355968000000000).toString());
                }
                return (data?.data ? data.data : null)
            })
                
            
            
            }
          } else { //offline
            // se ci sono info nel localstorage e sono parsabili
            if(isJsonParsable(localStorage.getItem(localSt))) {
              // ritorna i dati
              return JSON.parse(localStorage.getItem(localSt) || '' );
            }
          }
          
        } catch(err) {
          console.log(err);
          if(isJsonParsable(localStorage.getItem(localSt))) {
            return JSON.parse(localStorage.getItem(localSt) || '' );
          } else {
            // exitFromApplication();
          }
        }
}

export async function _getAxiosWithoutInterceptor(url: string, serviceTimeName: string, localSt: string, queryParams?: URLSearchParams){
  try {

      let urlService: string;
      if(queryParams){
          urlService = `${url}?${queryParams}`;
      } else {
          urlService = url;
      }
      
        let isOnline;
        // getIsOnline().then(s => isOnline = s)
        isOnline = navigator.onLine;
        if (isOnline) {
          const now:number = moment().valueOf() * 10000 + 621355968000000000;
          if( localStorage.getItem(serviceTimeName) ) {
            const serviceTime: number = parseInt(localStorage.getItem(serviceTimeName) || '0');
            if((now - serviceTime) >= 72000000000) { // 72000000000 --> 2 hour

              return await apiWithoutInterceptor.get(urlService, {
                  headers: queryParams ? setAxiosHeader(url, queryParams) : setAxiosHeader(url),
              }).then( data => {
                  // console.log("chiamata axios --> " + JSON.stringify(data.data));
                  if(localSt){
                    localStorage.setItem(localSt,JSON.stringify(data.data));
                    localStorage.setItem(serviceTimeName, (moment().valueOf() * 10000 + 621355968000000000).toString());
                  }
                  
                  return data.data
              })

            } else {
              if(isJsonParsable(localStorage.getItem(localSt))) {
                return JSON.parse(localStorage.getItem(localSt) || '' );
              }
            }
          } else {


          return await apiWithoutInterceptor.get(urlService, {
              headers: queryParams ? setAxiosHeader(url, queryParams) : setAxiosHeader(url),
          }).then( data => {
              // console.log("chiamata axios --> " + JSON.stringify(data.data));
              if(localSt){
              localStorage.setItem(localSt,JSON.stringify(data.data));
              localStorage.setItem(serviceTimeName, (moment().valueOf() * 10000 + 621355968000000000).toString());
              }
              return data.data
          })
              
          
          
          }
        } else { //offline
          if(isJsonParsable(localStorage.getItem(localSt))) {
            return JSON.parse(localStorage.getItem(localSt) || '' );
          }
        }
        
      } catch(err) {
        console.log(err);
        if(isJsonParsable(localStorage.getItem(localSt))) {
          return JSON.parse(localStorage.getItem(localSt) || '' );
        } else {
          // exitFromApplication();
        }
      }
}

// Variante senza alcuna logica di cache, localStorage o controlli temporali
export async function _getAxiosWithoutInterceptorNoCache(url: string, queryParams?: URLSearchParams) {
  try {
      let urlService: string;
      if (queryParams) {
          urlService = `${url}?${queryParams}`;
      } else {
          urlService = url;
      }

      // Effettua sempre una nuova chiamata HTTP senza consultare localStorage
      const response = await apiWithoutInterceptor.get(urlService, {
          headers: queryParams ? setAxiosHeader(url, queryParams) : setAxiosHeader(url)
      });

      // Restituisce direttamente i dati senza salvare su localStorage
      return response.data;
  } catch (err) {
      console.error(err);
      // Non tenta di leggere dal localStorage, né da serviceTimeName.
      throw err;
  }
}

export function setAxiosHeader4Post( body?: any){
  let userInfo: loginModel = JSON.parse(localStorage.getItem("user") || '""');
  let ticksDateExpireOn  = (( moment().valueOf() * 10000) + 621355968000000000); //ticks

  let FidelitySalusTS= ticksDateExpireOn ? ticksDateExpireOn.toString() : '0';
  let FidelitySalusToken = userInfo.token; 
  let secretKey1 = userInfo.secretKey1;
  let secretKey2 = userInfo.secretKey2;

  const headers: AxiosHeaders = new AxiosHeaders();
  headers.set('Content-Type', 'application/json');
  headers.set('Access-Control-Allow-Origin', '*');
  headers.set('Accept', 'application/json');

  let FidelitySalusMessageAuth: string;

      FidelitySalusMessageAuth = secretKey1+'.'+`${JSON.stringify(body)}`+'.'+FidelitySalusTS+'.'+secretKey2;
  
  

  headers.set('FidelitySalus-MessageAuth', Md5.hashAsciiStr(FidelitySalusMessageAuth));
  headers.set('FidelitySalus-TS', FidelitySalusTS);
  headers.set('FidelitySalus-Token', FidelitySalusToken);

  return headers;
}